import { createContext, useContext, useState } from "react";

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [sellerAppOpen, setSellerAppOpen] = useState(false);
  return (
    <UIContext.Provider value={{
      sellerAppOpen,
      openSellerApp: () => setSellerAppOpen(true),
      closeSellerApp: () => setSellerAppOpen(false),
    }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => useContext(UIContext);
